// /home/szymon/kreator2/frontend/src/DropZone.js
import React, { useState, useRef } from 'react';

export default function DropZone({ onImageDropped, acceptAllFiles = false }) {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      if (file && file.size) {
        readAndSendFile(file);
      }
    }
  };

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (file && file.size) {
        readAndSendFile(file);
      }
    }
  };

  const readAndSendFile = (file) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      onImageDropped?.({
        file,
        name: file.name,
        base64: evt.target.result
      });
    };
    reader.readAsDataURL(file);
  };

  const containerStyle = {
    border: isDragging ? '3px dashed #369' : '3px dashed #ccc',
    borderRadius: '8px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    color: isDragging ? '#369' : '#999',
    width: '180px',
    margin: '0 auto'
  };

  return (
    <div
      style={containerStyle}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      {isDragging
        ? 'Upuść plik tutaj...'
        : 'Przeciągnij i upuść lub kliknij'}
      <input
        type="file"
        accept={acceptAllFiles ? '*/*' : 'image/*'}
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </div>
  );
}
